module.exports = __webpack_public_path__ + "static/media/checkbox-enable.69ddb708.svg";